/**
 * @generated SignedSource<<b5e7746a103df83550bdda76eb8415f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"actionMenu_softwareReleasesVersionDetailIssueList_devOpsFeatureFlagProviders">;
  readonly " $fragmentType": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders";
}>;
export type addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders$key = ReadonlyArray<{
  readonly " $data"?: addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders$data;
  readonly " $fragmentSpreads": FragmentRefs<"addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_devOpsFeatureFlagProviders",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "actionMenu_softwareReleasesVersionDetailIssueList_devOpsFeatureFlagProviders"
    }
  ],
  "type": "DevOpsFeatureFlagProvider"
};

(node as any).hash = "9b78d95e09cfbfd2c5af5b680d6fc543";

export default node;
